export default {"src":"/_next/static/media/arrow-left.5ce01572.svg","height":19,"width":28};